import { Component, computed, EventEmitter, input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ChatOption } from '../../models/chat.models';
import { SkillType } from '../../enums/chat.enum';

@Component({
  selector: 'app-quick-select-options',
  templateUrl: './quick-select-options.component.html',
  styleUrl: './quick-select-options.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class QuickSelectOptionsComponent {

  // Inputs
  options = input<ChatOption[]>([]);
  isMobileApp = input<boolean>(false);
  isCcuApp = input<boolean>(false);
  isLoading = input<boolean>(false);
  
  DEFAULT_GROUP_ID = 'default';

  // Outputs
  @Output() selected = new EventEmitter<ChatOption>();

  // Group quick options by groupId and sort them by presentation order
  groupedQuickSelectOptions = computed(() => {
    const options = this.options();

    const groupMap = new Map<string, {
      groupId: string;
      groupName: string;
      options: any[];
    }>();

    options.forEach(option => {
      const groupId = option.presentationData.groupId ?? this.DEFAULT_GROUP_ID;
      const groupName = option.presentationData.groupName ?? '';

      if (!groupMap.has(groupId)) {
        groupMap.set(groupId, {
          groupId,
          groupName,
          options: []
        });
      }

      groupMap.get(groupId)!.options.push({
        ...option
      });
    });
    return Array.from(groupMap.values()).map(group => ({
      ...group,
      options: group.options.sort(
        (a, b) =>
          a.presentationData.order - b.presentationData.order
      )
    }));
  });

  skillTypes = SkillType;

  constructor() { }

  // When a quick option is selected, emit the selected option to the parent component
  selectOption(option: ChatOption): void {
    this.selected.emit({ ...option });
  }
}
